import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import JoinNowFormPopup from "../../../componants/JoinNowFormPopup";

// Helper component for Star Rating
const StarRating = ({ rating }: { rating: number }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <svg
        key={i}
        className={`h-4 w-4 ${
          i <= rating ? "text-yellow-400" : "text-gray-300"
        } inline-block`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
      </svg>
    );
  }
  return <div className="flex items-center">{stars}</div>;
};

// Helper component for Verified Badge
const VerifiedBadge = () => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ml-2">
    <svg
      className="w-3 h-3 mr-1"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
    Verified
  </span>
);

// Helper component for Google Badge
const GoogleBadge = () => (
    <span className="ml-2">
        <img src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png" alt="Google" className="h-4 w-4 inline-block" />
    </span>
);


const PhpTrainingInNoida = () => {
  const testimonials = [
    {
      id: 1,
      name: "Rahul Sharma",
      review:
        "The PHP training at Nadezhda Venture was incredibly practical and insightful. I learned modern PHP features, Laravel, and how to build robust web applications. The instructors were supportive and highly skilled. Highly recommended!",
      rating: 5,
      date: "2024-07-29",
      profileImg: "https://t4.ftcdn.net/jpg/03/64/21/11/360_F_364211147_1zLk0b3Jz254E0FvgpSfXhVbPvj0G24P.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 2,
      name: "Priya Singh",
      review:
        "I joined for PHP and MySQL training, and it exceeded my expectations. The hands-on projects helped me understand database integration perfectly. I now feel confident in developing dynamic websites. Excellent placement assistance!",
      rating: 4,
      date: "2024-07-28",
      profileImg: "https://image.shutterstock.com/image-photo/young-handsome-man-beard-wearing-260nw-1748111964.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 3,
      name: "Amit Kapoor",
      review:
        "Nadezhda Venture is truly the best PHP institute in Noida. Their curriculum for web development, including Laravel and API development, is cutting-edge. The interactive sessions and real-world case studies were invaluable.",
      rating: 5,
      date: "2024-07-27",
      profileImg: "https://i.pinimg.com/736x/87/40/3c/87403c9d78e7275085d34237f3743a3d.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 4,
      name: "Sneha Gupta",
      review:
        "After completing my PHP training here, I got a Web Developer role. The focus on backend development, REST APIs, and version control was incredibly helpful. The trainers are highly experienced and provide great guidance.",
      rating: 4,
      date: "2024-07-26",
      profileImg: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&h=400&fit=crop&ixid=eyJhcHBfaWQiOjEyMDd9",
      source: "Google",
      verified: true,
    },
    {
      id: 5,
      name: "Vikram Das",
      review:
        "Excellent PHP course! I gained a strong understanding of core PHP, OOP in PHP, and popular CMS platforms like WordPress. The learning environment fosters growth, with ample opportunities for coding practice.",
      rating: 5,
      date: "2024-07-25",
      profileImg: "https://expertphotography.com/wp-content/uploads/2020/08/profile-photos-4.jpg",
      source: "Google",
      verified: true,
    },
    {
      id: 6,
      name: "Deepak Verma",
      review:
        "This is undoubtedly the best place for PHP training in Noida. The faculty's expertise in full-stack web development and secure coding practices is exceptional. The personalized guidance helped me immensely in building my portfolio.",
      rating: 5,
      date: "2024-07-29",
      profileImg: "https://media.licdn.com/dms/image/D4D03AQEaVlXmO6jR-g/profile-displaythumbnail-shrink_200_200/0/1666699268686?e=2147483647&v=beta&t=7u7Wk3P6R7c-M-Y1k3M-2w-N4z-3a-J2q-G6x-B9x-Q",
      source: "Google",
      verified: true,
    },
    {
      id: 7,
      name: "Kavya Sharma",
      review:
        "I was placed as a Junior Web Developer after completing my PHP course from Nadezhda. The interview preparation and live project experience were extremely helpful. Highly recommend their comprehensive approach!",
      rating: 4,
      date: "2024-07-28",
      profileImg: "https://img.freepik.com/free-photo/young-indian-man-posing-outdoor_23-2150756773.jpg?size=626&ext=jpg&ga=GA1.1.1826414947.1699574400&semt=ais",
      source: "Google",
      verified: true,
    },
  ];

  const faqContent = [
    {
      title: "What is PHP and why should I learn it?",
      answer:
        "PHP (Hypertext Preprocessor) is a widely-used open source scripting language especially suited for web development and can be embedded into HTML. It is powerful for building dynamic and interactive websites, web applications, and APIs, powering major platforms like WordPress, Facebook, and Wikipedia.",
    },
    {
      title: "What are the prerequisites for joining PHP training?",
      answer:
        "There are no strict programming prerequisites, though basic understanding of HTML and CSS is beneficial. Our course starts from the absolute basics of PHP, covering fundamental concepts and gradually moving to advanced web development, suitable for beginners and those with some web knowledge.",
    },
    {
      title: "What topics are covered in your PHP course?",
      answer:
        "Our comprehensive PHP course covers PHP fundamentals, syntax, data types, operators, control structures, functions, arrays, and string manipulation. It deeply dives into Object-Oriented Programming (OOP) in PHP, form handling, session management, file I/O, error handling, and security. It also includes extensive training on MySQL database integration, MVC architecture, and popular frameworks like Laravel, along with an introduction to APIs and CMS (e.g., WordPress).",
    },
    {
      title: "How is the PHP training delivered (online/offline)?",
      answer:
        "We offer flexible training modes including intensive offline classroom sessions at our Noida center and interactive online classes. Both modes feature live instructor-led sessions, extensive practical exercises, and project-based learning to ensure a strong grasp of concepts.",
    },
    {
      title: "Will I get placement assistance after completing the course?",
      answer:
        "Yes, we provide dedicated placement assistance to our PHP graduates. This includes resume building, interview preparation, mock interviews, and connecting you with our network of hiring partners in Noida and across India, particularly in the web development domain.",
    },
    {
      title: "What kind of projects will I work on during the training?",
      answer:
        "You will work on multiple hands-on projects, ranging from basic dynamic websites to more complex web applications. This could include a blog system, an e-commerce platform, a task management application, or a custom CMS, integrating PHP with a database and a framework.",
    },
    {
      title: "Is there a certification provided after the PHP course?",
      answer:
        "Yes, upon successful completion of the PHP training and project work, you will receive a course completion certificate from Appwars Technologies, which is recognized by industry professionals and helps validate your web development skills.",
    },
  ];

  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
      const [selectedCourseTitle, setSelectedCourseTitle] = useState(""); // State to store the course title
    
      const handleOpenPopup = (courseTitle: string) => { // Function to open the popup
        setSelectedCourseTitle(courseTitle); // Set the selected course title
        setIsPopupOpen(true); // Open the popup
      };
    
      const handleClosePopup = () => { // Function to close the popup
        setIsPopupOpen(false); // Close the popup
        setSelectedCourseTitle(""); // Clear selected course when closing
      };

  const curriculumContent = [
    {
      title: "Module 1: PHP Fundamentals & Syntax",
      description: "Introduction to PHP, environment setup (XAMPP/LAMP), basic syntax, data types, variables, operators, conditional statements (if-else, switch), loops (for, while, foreach).",
    },
    {
      title: "Module 2: Functions, Arrays, and Strings",
      description: "Defining and calling functions, built-in functions, array manipulation (indexed, associative, multidimensional), string functions, and regular expressions.",
    },
    {
      title: "Module 3: Form Handling & Superglobals",
      description: "Processing HTML forms with PHP, understanding `$_GET`, `$_POST`, `$_REQUEST`, `$_SESSION`, `$_COOKIE`, and `$_FILES`. Form validation and sanitization.",
    },
    {
      title: "Module 4: Object-Oriented Programming (OOP) in PHP",
      description: "Concepts of classes, objects, properties, methods, constructors, destructors, inheritance, polymorphism, abstraction, encapsulation, traits, and interfaces.",
    },
    {
      title: "Module 5: Database Integration with MySQL",
      description: "Introduction to relational databases, SQL queries (CRUD operations), connecting PHP to MySQL using MySQLi and PDO. Database design principles.",
    },
    {
      title: "Module 6: Session Management & Error Handling",
      description: "Implementing user authentication and authorization, managing sessions and cookies for user state. Error reporting, custom error handlers, and exception handling.",
    },
    {
      title: "Module 7: Introduction to Web Development Frameworks (Laravel)",
      description: "Understanding MVC architecture. Introduction to Laravel: routing, controllers, views, Eloquent ORM, migrations, and basic CRUD operations.",
    },
    {
      title: "Module 8: Building RESTful APIs with PHP & Laravel",
      description: "Principles of REST, designing and developing RESTful APIs using Laravel. Authentication for APIs (e.g., Sanctum), API versioning, and testing APIs.",
    },
    {
      title: "Module 9: CMS Development (WordPress Basics)",
      description: "Introduction to WordPress: installation, dashboard, themes, plugins. Custom post types, custom fields. Understanding WordPress as a PHP application.",
    },
    {
      title: "Module 10: Advanced Topics & Project Work",
      description: "Composer for dependency management, security best practices (SQL injection, XSS prevention), deploying PHP applications. Capstone project integrating learned concepts to build a complete web application.",
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  useEffect(() => {
    const autoScrollInterval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(autoScrollInterval); // Clean up the interval
  }, [testimonials.length]);

  const goToPrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex + 1) % testimonials.length
    );
  };

  const getVisibleTestimonialsCount = () => {
    if (window.innerWidth >= 1024) return 3; // lg breakpoint
    if (window.innerWidth >= 768) return 2;  // md breakpoint
    return 1; // default for small screens
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleTestimonialsCount());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleTestimonialsCount());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const startIndex = currentTestimonialIndex;
  const currentVisibleTestimonials = [];

  // Logic to handle showing multiple cards and wrapping around
  for (let i = 0; i < visibleCount; i++) {
    currentVisibleTestimonials.push(testimonials[(startIndex + i) % testimonials.length]);
  }


  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>PHP Training in Noida | Best PHP Course with Laravel & MySQL</title>
        <meta
          name="description"
          content="Master PHP development with our comprehensive training in Noida. Learn core PHP, MySQL, Laravel, and build dynamic web applications with hands-on projects and placement support."
        />
        <meta
          name="keywords"
          content="PHP training Noida, PHP course, PHP certification, PHP coaching Noida, Laravel training, MySQL, Web Development, Backend Development, WordPress development"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden text-white h-[400px] bg-gray-900 flex items-center">
        <img
          src="https://t3.ftcdn.net/jpg/04/93/78/48/360_F_493784893_cX6SXtINJnN8SEracNXi6xMnag7HKA1N.jpg"
          alt="PHP Training Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
         {/* Dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

       <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 flex flex-col md:flex-row items-center md:items-start">
               <div className="md:w-1/2">
                 <motion.h1
                   initial={{ opacity: 0, y: 30 }}
                   animate={{ opacity: 1, y: 0 }}
                   transition={{ duration: 0.8 }}
                   className="text-4xl md:text-5xl font-extrabold leading-tight text-left"
                 >
                   <span className="text-orange-600">PHP</span> Training in Noida
                 </motion.h1>
       
                 <motion.p
                   initial={{ opacity: 0, y: 20 }}
                   animate={{ opacity: 1, y: 0 }}
                   transition={{ delay: 0.3, duration: 0.8 }}
                   className="mt-6 text-lg md:text-xl text-gray-200 text-left"
                 >
                   Join Nadezhda Venture for expert-led PHP Training in Noida. Build dynamic web applications with hands-on projects and certification support.
                 </motion.p>
       
                 <motion.button
                   initial={{ opacity: 0, y: 20 }}
                   animate={{ opacity: 1, y: 0 }}
                   transition={{ delay: 0.6, duration: 0.8 }}
                   className="mt-8 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 ease-in-out"
                 >
                  <button
                    // className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg font-semibold transition text-white"
                    onClick={() => handleOpenPopup("PHP Full Stack Development Training")} // Pass the course title
                  >
                    Enroll Now !
                  </button>
                 </motion.button>
               </div>
               </div>
      </section>

      {/* Why PHP Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Why Learn PHP?</h2>
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
            PHP is the backbone of over 70% of the web, powering dynamic websites and robust web applications. It offers a fast learning curve, extensive community support, and seamless integration with databases, making it essential for web developers.
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-10">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-blue-700 mb-3">Dominant Web Technology</h3>
              <p className="text-gray-600">Powers major websites like WordPress, Facebook, and Wikipedia.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-blue-700 mb-3">Backend Development</h3>
              <p className="text-gray-600">Essential for server-side scripting, database interaction, and API creation.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-blue-700 mb-3">Rich Ecosystem</h3>
              <p className="text-gray-600">Vast frameworks (Laravel, Symfony) and CMS options (WordPress, Drupal).</p>
            </div>
          </div>
        </div>
      </section>

      {/* Course Highlights Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Course Highlights</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: '🚀', title: 'Comprehensive Web Development', desc: 'Build dynamic, data-driven web applications from scratch.' },
              { icon: '💡', title: 'Hands-on Frameworks & Databases', desc: 'Master Laravel and MySQL with practical, real-world projects.' },
              { icon: '👨‍🏫', title: 'Experienced Industry Trainers', desc: 'Learn from experts with extensive experience in PHP development.' },
              { icon: '🎓', title: 'Globally Recognized Certification', desc: 'Enhance your profile with our industry-aligned course certificate.' },
              { icon: '🤝', title: 'Dedicated Placement Assistance', desc: 'Receive comprehensive support for resume building, mock interviews, and job placements.' },
              { icon: '🔄', title: 'Flexible Learning Options', desc: 'Choose between immersive offline classroom or interactive online sessions.' },
            ].map((item, index) => (
              <motion.div
                key={index}
                className="bg-blue-50 p-6 rounded-lg shadow-md flex items-start space-x-4"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-4xl">{item.icon}</div>
                <div>
                  <h3 className="font-semibold text-xl text-blue-800 mb-2">{item.title}</h3>
                  <p className="text-gray-700">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Curriculum Overview Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Detailed Curriculum Overview</h2>
          <div className="space-y-4">
            {curriculumContent.map((module, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {module.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{module.description}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tools & Technologies */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Tools & Technologies You'll Master</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
            Our PHP training ensures you gain proficiency in the essential tools, frameworks, and databases used in modern web development.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-center">
            {[
              { name: 'PHP', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg' },
              { name: 'MySQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
              { name: 'Laravel', logo: 'https://webol.co.uk/wp-content/uploads/2024/12/62a4c8c5fdee15d2905007ca.png' },
              { name: 'WordPress', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg' },
              { name: 'Apache HTTP Server', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg' },
              { name: 'Composer', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/composer/composer-original.svg' },
              { name: 'VS Code', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg' },
              { name: 'Git', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg' },
            ].map((tool, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-center p-4 bg-gray-100 rounded-lg shadow-sm"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <img src={tool.logo} alt={tool.name} className="h-12 mb-2" />
                <p className="text-gray-700 font-medium text-sm">{tool.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Career Opportunities */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Exciting Career Opportunities</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto">
            A PHP certification from Appwars Technologies can unlock a wide array of high-demand job roles in the web development industry.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: '🌐', title: 'PHP Developer', desc: 'Build and maintain server-side logic for web applications.' },
              { icon: '💻', title: 'Web Developer', desc: 'Create dynamic websites using PHP, databases, and frameworks.' },
              { icon: '🔄', title: 'Full Stack Developer', desc: 'Develop both frontend and backend components of web applications.' },
              { icon: '✍️', title: 'WordPress Developer', desc: 'Specialize in customizing, developing, and maintaining WordPress sites.' },
              { icon: '🛠️', title: 'Backend Developer', desc: 'Focus on server-side programming, APIs, and database management.' },
              { icon: '🚀', title: 'API Developer', desc: 'Design and implement robust RESTful APIs for various services.' },
            ].map((role, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-5xl mb-4">{role.icon}</div>
                <h3 className="font-semibold text-xl text-blue-800 mb-2">{role.title}</h3>
                <p className="text-gray-700">{role.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>


      {/* Course Content / FAQ Section */}
      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center md:text-left">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {faqContent.map((section, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {section.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{section.answer}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>

        {/* Enquiry Form */}
        <div className="md:col-span-1 pt-20">
          <div className="bg-blue-300 rounded-lg p-6 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-center text-blue-800">Enquire Now</h3>
            <p className="text-center text-gray-600 mb-6">Fill out the form below to get more details about our PHP training program.</p>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="Course of Interest (e.g., PHP Training)"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="College/University Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-800 hover:bg-blue-700 text-white py-3 rounded-md font-semibold transition duration-300 ease-in-out shadow-md hover:shadow-lg"
              >
                JOIN THE PROGRAM
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Testimonial Section - No Horizontal Scrollbar */}
      <section className="bg-blue-50 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-blue-900">Our Students Say</h2>

          <div className="relative overflow-hidden w-full mx-auto">
            {/* Left Scroll Button */}
            <button
              onClick={goToPrevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Previous testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            {/* Testimonial Cards Container */}
            <div className="flex justify-center items-stretch space-x-6 md:space-x-8 lg:space-x-10">
              <AnimatePresence mode="wait" initial={false}>
                {currentVisibleTestimonials.map((testimonial, idx) => (
                  <motion.div
                    key={testimonial.id}
                    initial={{ opacity: 0, x: idx * 100 }} // Initial position based on index in visible set
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="flex-none w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)] p-2"
                  >
                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 flex flex-col h-full text-left">
                      <div className="flex items-center mb-4">
                        <img
                          src={testimonial.profileImg}
                          alt={testimonial.name}
                          className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-blue-200"
                        />
                        <div>
                          <p className="font-bold text-gray-900 text-lg">
                            {testimonial.name}
                          </p>
                          <p className="text-gray-500 text-sm">{testimonial.date}</p>
                        </div>
                        {testimonial.source === "Google" && <GoogleBadge />}
                      </div>
                      <div className="flex items-center mb-3">
                        <StarRating rating={testimonial.rating} />
                        {testimonial.verified && <VerifiedBadge />}
                      </div>
                      <p className="text-gray-700 text-base leading-relaxed flex-grow line-clamp-4">
                        {testimonial.review}
                      </p>
                      <a href="#" className="text-blue-600 hover:underline mt-4 text-sm text-right">
                        Read more
                      </a>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Right Scroll Button */}
            <button
              onClick={goToNextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Next testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                className={`h-3 w-3 rounded-full ${
                  // Logic to highlight dots based on the current set of visible testimonials
                  idx >= currentTestimonialIndex && idx < currentTestimonialIndex + visibleCount
                    ? "bg-blue-600"
                    : "bg-gray-300"
                } transition-colors duration-300`}
                onClick={() => setCurrentTestimonialIndex(idx)}
                aria-label={`Go to testimonial group ${idx + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </section>

      {/* Conditionally render the popup */}
            {isPopupOpen && (
              <JoinNowFormPopup
                onClose={handleClosePopup}
                courseTitle={selectedCourseTitle}
              />
            )}
    </div>
  );
};

export default PhpTrainingInNoida;